import store from '@/state/store'
import { hasLineOrderFeatureAccess } from '@/helpers/tms-line-order'

const hasAccessAll = store.getters['identity/hasAccessAll']
const getFeatureFlagValue = store.getters['identity/getFeatureFlagValue']

const hasTmsUserGroupAccess = hasAccessAll(['tms-user-group:read'])
const showLineOrder = hasLineOrderFeatureAccess() ? true : false

const getDOListFields = (self) => {
  const statusStickyLeft = showLineOrder ? '379.5px' : '279.5px'

  return [
    {
      label: self.$t('routeOptimization.fields.deliveryNumber'),
      key: 'number',
      isSortable: true,
      isRedirectable: true,
      hasOpenNewTab: true,
      isLocked: true,
      tdAttr: {
        style: 'left:99.5px;position:sticky;min-width:180px;max-width:180px;z-index:1;',
      },
      thAttr: {
        style: 'left:99.5px;position:sticky;min-width:180px;max-width:180px;z-index:1;',
      },
    },
    {
      label: 'Line Order',
      key: 'line_order',
      isSortable: true,
      isShow: showLineOrder,
      isLocked: true,
      tdAttr: {
        style: 'left:279.5px;position:sticky;min-width:100px;max-width:100px;z-index:1;',
      },
      thAttr: {
        style: 'left:279.5px;position:sticky;min-width:100px;max-width:100px;z-index:1;',
      },
    },
    {
      label: self.$t('routeOptimization.fields.status'),
      key: 'status.name',
      isLocked: true,
      tdAttr: {
        style: `left:${statusStickyLeft};position:sticky;z-index:1;`,
      },
      thAttr: {
        style: `left:${statusStickyLeft};position:sticky;z-index:1;`,
      },
    },
    {
      label: self.$t('routeOptimization.fields.originAddress'),
      key: 'origin_address.name',
      isSortable: true,
      isEllipsis: true,
    },
    {
      label: self.$t('routeOptimization.fields.destinationAddress'),
      key: 'destination_address.name',
      isSortable: false,
      isEllipsis: true,
    },
    {
      label: self.$t('routeOptimization.fields.shipmentNumber'),
      key: 'shipment_number',
      isSortable: false,
      isEllipsis: true,
    },
    {
      label: self.$t('routeOptimization.fields.referenceNumber'),
      key: 'reference_number',
      isSortable: false,
      isEllipsis: true,
    },
    {
      label: self.$t('routeOptimization.fields.createdOn'),
      key: 'created_on',
      isSortable: true,
    },
    {
      label: self.$t('routeOptimization.fields.expectedPickupOn'),
      key: 'expected_pickup_on',
      isSortable: true,
    },
    {
      label: self.$t('routeOptimization.fields.expectedDeliveredOn'),
      key: 'expected_delivered_on',
      isSortable: true,
    },
    {
      label: self.$t('global.field.userGroup'),
      key: 'user_group.name',
      isSortable: true,
      isShow: hasTmsUserGroupAccess,
      isEllipsis: true,
    },
    {
      label: self.$t('routeOptimization.fields.createdBy'),
      key: 'created_by',
      isSortable: true,
    },
    {
      label: self.$t('routeOptimization.fields.shippedCustomerName'),
      key: 'shipped_customer.name',
      isSortable: true,
      isEllipsis: true,
    },
    {
      label: self.$t('routeOptimization.fields.billedCustomerName'),
      key: 'billed_customer.name',
      isSortable: true,
      isEllipsis: true,
    },
    {
      label: self.$t('routeOptimization.fields.marketingStaff'),
      key: 'marketing_user.name',
      isSortable: true,
      isEllipsis: true,
    },
    {
      label: self.$t('routeOptimization.fields.productCategory'),
      key: 'product_categories',
      isSortable: false,
    },
    {
      label: self.$t('routeOptimization.fields.loadWeight'),
      key: 'load_weight',
      isSortable: true,
    },
    {
      label: self.$t('routeOptimization.fields.loadVolume'),
      key: 'load_volume',
      isSortable: true,
    },
  ].filter((field) => field?.isShow !== false)
}

export default getDOListFields
